import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";

import { stopEventPropagation } from "@hermes/utils-generic-helpers";

import { LayoutFacade } from "../../facades/layout.facade";
import { OverlayErrorMessageComponent } from "../overlay-error-message/overlay-error-message.component";

/**
 * Overlay for Notifications an loader displaying
 */
@Component({
    selector: "h-overlay",
    imports: [OverlayErrorMessageComponent, AsyncPipe],
    templateUrl: "./overlay.component.html",
    styleUrls: ["./overlay.component.scss"],
})
export class OverlayComponent {
    public layoutFacade = inject(LayoutFacade);

    /**
     * Function launched during a click or a keypress on the document, it prevent the default behavior and
     * stop it's propagation
     *
     * @param event Event lauched by the browser (could be a click, a touch or a keyboard event)
     */
    public lockApp(event: Event): void {
        stopEventPropagation(event);
    }
}
